import React from 'react'
import './Footer.css'
import { Link } from 'react-router-dom'
import Icon from '.././images/icon.svg'

function Footer() {
  return (
    <div className='footer-container'>
      <div class='footer-logo-section'>
        <Link to='/' className='footer-logo'>
          <div className='footer-logo-container'>
            <img src={Icon} alt='MPULE Institute' className='footer-icon' />
            <div className='footer-title'>
              <h1 className='footer-mpule'>MPULE</h1>
              <h1 className='footer-foundation'>Foundation</h1>
            </div>
          </div>
        </Link>
        <p className='copy-2021'>© 2021</p>
      </div>

      <div class='social-icons'>
        <Link
          class='social-icon-link facebook'
          to='/'
          target='_blank'
          aria-label='Facebook'
        >
          <i class='fab fa-facebook-f' />
        </Link>
        <Link
          class='social-icon-link instagram'
          to='/'
          target='_blank'
          aria-label='Instagram'
        >
          <i class='fab fa-instagram' />
        </Link>
        <Link
          class='social-icon-link youtube'
          to='/'
          target='_blank'
          aria-label='Youtube'
        >
          <i class='fab fa-youtube' />
        </Link>
        <Link
          class='social-icon-link twitter'
          to='/'
          target='_blank'
          aria-label='Twitter'
        >
          <i class='fab fa-twitter' />
        </Link>
        <Link
          class='social-icon-link twitter'
          to='/'
          target='_blank'
          aria-label='LinkedIn'
        >
          <i class='fab fa-linkedin' />
        </Link>
      </div>
    </div>
  )
}

export default Footer
